if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( document.getElementById('cart-recommendations') ) {
						document.getElementById('cart-recommendations').generateRecommendations();
					}
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
					});
					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
					})
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}
		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('click', (e)=>{
				e.preventDefault();
                const target = e.currentTarget;
                showQtyInput(target.dataset.variant)
                customAddToCart(target)
                return;

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="modal modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--medium">
									<div class="modal-content">
										<button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);

							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							if ( ! window.productPageScripts ) {
									
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								})

							}

							this.quickViewModal.querySelector('.product-quick-view__close').addEventListener('click', ()=>{
								this.quickViewModal.hide();
							});

							if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
								this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
									this.quickViewModal.hide();
								});
							}

							if ( Shopify && Shopify.PaymentButton ) {
								setTimeout(()=>{
									Shopify.PaymentButton.init();
								}, 50);
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);
							
						});

				} else {
					this.quickViewModal.show();
				}

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}

function showQtyInput(variant){
  $('.custom-atc-button-'+variant).addClass('d-none')
  $('.product-item__quick-buy[data-qid="'+variant+'"]').css('width', '100%')
  $('.qty-'+variant).removeClass('d-none')
}

function hideQtyInput(variant){
  $('.custom-atc-button-'+variant).removeClass('d-none')
  $('.product-item__quick-buy[data-qid="'+variant+'"]').css('width', 'auto')
  $('.qty-'+variant).addClass('d-none')
}

function customAddToCart(target){
  const data = {
    form_type: 'product',
    id: target.dataset.variant,
    quantity: 1,
    'product-id': target.dataset.id,
    'section-id': 'template--17695651004582__main'
  };
  let alert = '';
  fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
      body: new URLSearchParams(data).toString(),
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'POST'
  })
  .then(response => response.json())
  .then(response => {
      if ( response.status == 422 ) {
          // wrong stock logic alert
          alert = document.createElement('span');
          alert.className = 'alert alert--error';
          if ( typeof response.description === 'string' ) {
              alert.innerHTML = response.description;
          } else {
              alert.innerHTML = response.message;
          }
        //Hacer código para mostrar mensaje de error
      } else {
          if ( this.cartType == 'page' ) {
              document.location.href = KROWN.settings.routes.cart_url;
              return false;
          } else {
              return fetch('?section_id=helper-cart');
          }
      }
  })
  .then(response => response.text())
  .then(text => {

      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

      if ( document.getElementById('AjaxCartForm') ) {

          const cartItems = document.getElementById('AjaxCartForm');
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          if ( alert != '' ) {
              document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
          }

          document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

          document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
              elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
          });
          document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
              elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
          });

      }
      
      //this.dispatchEvent(this.ADD_TO_CART);

      // a11y
      if ( document.getElementById('screen-reader-info') ) {
          document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
          setTimeout(()=>{
              document.getElementById('screen-reader-info').innerText = '';
          }, 1000);
      }

  })
}

$(document).ready(function(){
  $('.custom-qty-button').on('click',function(){
    if($(this).hasClass('plus-btn')){
      customPlusQty($(this))
    }
    else{
      customMinusQty($(this))
    }
  })
  fetch(KROWN.settings.routes.cart_url+'.js', {
    method: 'GET'
  })
  .then(response => {
      if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
      }
      return response.json();
  })
  .then(data => {
      if(data.items.length > 0){
        for(const item of data.items){
          if($('.custom-atc-button-'+item.id).length > 0){
            $('.custom-qty-input-'+item.id).text(item.quantity)
            showQtyInput(item.id)
          }
        }
      }
  })
  .catch(error => {
      console.error('Error fetching the cart:', error);
  });
})

function customPlusQty($element){
  $('.qty-plus[controls="updates_'+$element.data("variant")+'"]').click()
  $('.custom-qty-input-'+$element.data("variant")).text(parseInt($('.custom-qty-input-'+$element.data("variant")).text())+1)
  $('.qty-'+$element.data("variant")).addClass('working')
  setTimeout(() => {
    $('.qty-'+$element.data("variant")).removeClass('working')
  }, 500);
}
function customMinusQty($element){
  $('.qty-minus[controls="updates_'+$element.data("variant")+'"]').click()
  if(parseInt($('.custom-qty-input-'+$element.data("variant")).text())-1 != 0){
    $('.custom-qty-input-'+$element.data("variant")).text(parseInt($('.custom-qty-input-'+$element.data("variant")).text())-1)
    $('.qty-'+$element.data("variant")).addClass('working')
    setTimeout(() => {
      $('.qty-'+$element.data("variant")).removeClass('working')
    }, 500);
  }
  else{
    hideQtyInput($element.data("variant"))
  }
}